<!-- 采购入仓 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="dialog-header" v-if="tcrkType == 1">
            <div>
                <el-button v-if="!isTcrkModel" class="btn-primary" size="small" @click="isTcrkModel = true">同仓入库</el-button>
                <el-select
                    v-if="isTcrkModel"
                    v-model="tcrkWarehouseId"
                    size="small"
                    filterable
                    clearable
                    style="margin-right: 20px"
                    @change="
                        val => {
                            (tcrkShelfSpaceId = ''), (tcrkShelfSpaceOptions = []);
                        }
                    "
                >
                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId"> </el-option>
                </el-select>
                <el-select
                    v-if="isTcrkModel"
                    v-model="tcrkShelfSpaceId"
                    :loading="loading"
                    filterable
                    clearable
                    reserve-keyword
                    remote
                    :remote-method="value => tcrkRemoteMethod(value, tcrkWarehouseId)"
                    @visible-change="
                        value => {
                            if (value && tcrkShelfSpaceOptions == 0) tcrkRemoteMethod('', tcrkWarehouseId);
                        }
                    "
                    size="small"
                >
                    <el-option v-for="item in tcrkShelfSpaceOptions" :key="item.ShelfSpaceId" :label="item.ShelfSpaceCode" :value="item.ShelfSpaceId"> </el-option>
                </el-select>
            </div>
            <div v-if="isTcrkModel">
                <el-button size="small" @click="isTcrkModel = false">取消</el-button>
                <el-button class="btn-primary" size="small" @click="tcrkSubmitData">入仓</el-button>
            </div>
        </div>
        <div class="tips" v-if="tcrkType == 1">整单商品入库到同一仓位下</div>
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 20%">配件名称</div>
                <div class="div-table-cell" style="width: 20%">配件编码</div>
                <div class="div-table-cell flex" style="width: 60%">
                    <div class="border-right cell-item" style="width: 30%">仓库</div>
                    <div class="border-right cell-item" style="width: 30%">仓位</div>
                    <div class="border-right cell-item" style="width: 20%">数量</div>
                    <div class="cell-item" style="width: 20%"></div>
                </div>
            </div>
            <div class="table-main">
                <div class="div-table-row" v-for="(goods, index) in goodsList" :key="goods.EntpTempGoodsId">
                    <div class="div-table-cell" style="width: 20%">
                        {{ goods.GoodName }}
                    </div>
                    <div class="div-table-cell" style="width: 20%">
                        {{ goods.APCode }}
                    </div>
                    <div class="div-table-cell" style="width: 60%">
                        <!--循环仓库、仓位-->
                        <div class="cell-line" v-for="(shelfSpace, i) in goods.GoodsLocationList" :key="i.key">
                            <div class="border-right cell-item" style="width: 30%">
                                <el-select
                                    v-model="shelfSpace.WarehouseId"
                                    size="small"
                                    filterable
                                    clearable
                                    @change="warehouseChange($event, goods, shelfSpace)"
                                    :disabled="isTcrkModel"
                                >
                                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 30%">
                                <span style="color: #409eff" v-if="goods.searching">推荐中 <i class="el-icon-loading"></i></span>
                                <el-select
                                    v-else
                                    v-model="shelfSpace.ShelfSpaceId"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    remote
                                    :remote-method="val => remoteMethod(val, goods.EntpTempGoodsId)"
                                    v-select-scroll-more="remoteMethodScrollMore"
                                    @change="positionChange($event, goods, shelfSpace)"
                                    @visible-change="positionVisibleChange($event, shelfSpace.WarehouseId, shelfSpace, goods.EntpTempGoodsId)"
                                    size="small"
                                    :disabled="isTcrkModel"
                                    @focus="shelfSpaceFocus(index, i, shelfSpace, goods)"
                                >
                                    <el-option
                                        v-for="optionItem in shelfSpace.ShelfSpacesList"
                                        :key="optionItem.ShelfSpaceId"
                                        :label="optionItem.ShelfSpaceCode"
                                        :value="optionItem.ShelfSpaceId"
                                    >
                                        <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                                        <span v-if="!isNaN(optionItem.Count)">库存:{{ optionItem.Count }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 20%">
                                <el-input size="small" type="number" v-model="shelfSpace.Count" min="0"> </el-input>
                            </div>
                            <div class="cell-item ops-ctn" style="width: 20%; height: 28px; margin-top: 7px">
                                <el-button size="mini" icon="el-icon-minus" @click="delItem(index, i)" :disabled="isTcrkModel"></el-button>
                            </div>
                        </div>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="add-btn ops-btn" @click="addItem(index)" :disabled="isTcrkModel"></el-button>
                </div>
            </div>
        </div>
        <div class="dialog-footer" v-if="!isTcrkModel">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button class="btn-primary" size="small" @click="submitData">入仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['tcrkType', 'EntpCusPOId', 'APList', 'OrderWarehouse'], //OrderWarehouse:订单选择的仓库
    components: {},
    data() {
        return {
            Limit: 10,
            loading: false,
            dailogLoading: true,
            WarehouseList: [],
            PositionList: [],
            formData: {
                EntpCusPOId: this.EntpCusPOId,
                GoodsList: [
                    {
                        EntpTempGoodsId: '',
                        GoodsLocationList: [
                            //仓位列表
                            {
                                ShelfSpaceId: '', //仓位Id
                                Count: ''
                            }
                        ]
                    }
                ]
            },
            goodsList: [], //入仓商品列表

            isTcrkModel: false, // 是否开启同仓入库模式
            tcrkWarehouseId: '', // 同仓入库仓库信息
            tcrkShelfSpaceId: '', // 同仓入库仓位信息
            tcrkShelfSpaceOptions: [], // 同仓入库仓位列表
            // 点击仓位时定位下拉框的下标，用于滚动搜索功能
            firstIndex: 0, // goodsList 的下标
            secoundIndex: 0, // goodsList[firstIndex].GoodsLocationList 的下标
            currentShelfSpaceObj: {}, // 当前的下拉框仓位数据
            getLatelySpace: false //是否获取商品最近在当前仓库下存放的仓位
        };
    },
    mounted() {
        let that = this;
        //获取仓库列表
        that.getWarehouse();
    },
    methods: {
        init() {
            let that = this;

            //仓位对象
            let spaceItem = {
                WarehouseId: '',
                ShelfSpaceCode: '',
                ShelfSpaceId: '',
                Count: 0, //入仓数量
                CountMax: 999,
                ShelfSpacesList: []
            };
            //如果原来订单有选仓库，默认使用选好的仓库
            if (that.OrderWarehouse) {
                for (let i = 0; i < that.WarehouseList.length; i++) {
                    if (that.WarehouseList[i].WarehouseId == that.OrderWarehouse.WarehouseId) {
                        spaceItem.ShelfSpacesList = that.WarehouseList[i].ShelfSpaces;
                        spaceItem.WarehouseId = that.OrderWarehouse.WarehouseId;
                        break;
                    }
                }
            }
            //处理入仓数据
            let _APList = [];

            for (let i = 0; i < that.APList.length; i++) {
                if (!that.APList[i].IsInStorage) {
                    //可入仓数等于商品总数减去已经入仓数量
                    //有打印标签的要注意，打印的标签，只能通过标签入仓  vam
                    if (that.APList[i].WarehousedCount > that.APList[i].InLabelCount) {
                        spaceItem.Count = that.APList[i].Count - that.APList[i].PrintCount - (that.APList[i].WarehousedCount - that.APList[i].InLabelCount);
                    } else spaceItem.Count = that.APList[i].Count - that.APList[i].PrintCount;
                    //spaceItem.Count=that.APList[i].Count-that.APList[i].WarehousedCount;

                    // spaceItem.CountMax=spaceItem.Count>0?spaceItem.Count:999;
                    //因为打标后可入仓数为零的不显示
                    if (spaceItem.Count > 0) {
                        // 多个层级影响，不能直接赋值，需要用set才能触发响应
                        this.$set(that.APList[i], 'GoodsLocationList', [{ ...spaceItem }]);
                        if (that.getLatelySpace) this.$set(that.APList[i], 'searching', true);

                        _APList.push(that.APList[i]);
                    }
                }
            }
            that.goodsList = _APList;
            if (_APList.length == 0) {
                that.$util.warningMsg('没有可入仓商品,请检查商品是否打印了标签');
            } else {
                that.tcrkWarehouseId = _APList[0].GoodsLocationList[0].WarehouseId;
            }

            that.dailogLoading = false;

            if (that.getLatelySpace && that.OrderWarehouse && that.goodsList.length > 0) {
                //获取商品最近在当前仓库下存放的仓位
                for (let i = 0; i < that.goodsList.length; i++) {
                    let goods = that.goodsList[i];
                    that.$util
                        .axiosGet({
                            url: '/api/EntpShelfSpaces/GetGoodsLatelyWarehousing',
                            data: {
                                GoodsId: goods.EntpTempGoodsId,
                                WarehouseId: that.OrderWarehouse.WarehouseId
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            let data = res.data;
                            if (data) {
                                goods.GoodsLocationList[0].ShelfSpaceCode = data.ShelfSpaceCode;
                                goods.GoodsLocationList[0].ShelfSpaceId = data.ShelfSpaceId;
                                goods.GoodsLocationList[0].ShelfSpacesList = [data];
                            }
                            goods.searching = false;
                        });
                }
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse().then(data => {
                this.WarehouseList = data;
                this.$util.getSysConfig('cgrczjcw').then(data => {
                    this.getLatelySpace = data && data.Result;
                    this.init();
                });
            });
        },
        // 搜仓位
        searchPosition(obj, warehouseId) {
            let that = this;
            if (!warehouseId || that.loading) return;
            that.loading = true;
            return (
                that.$util
                    // .GetShelfSpacesList( {
                    //     WarehouseId: warehouseId,
                    //     ShelfSpaceCode: obj.Key,
                    //     Page: obj.Page,
                    //     Limit: 20,
                    //     IsLimit: true,
                    //     IncludecWaste:false
                    //   })
                    .GetSSListForPurIn({
                        WarehouseId: warehouseId,
                        ShelfSpaceCode: obj.Key,
                        GoodsId: obj.GoodsId,
                        Page: obj.Page,
                        Limit: 20
                    })
                    .then(res => {
                        that.loading = false;
                        if (res.data) {
                            that.PositionList = res.data;
                        } else {
                            that.$util.warningMsg('该仓库暂无仓位');
                        }
                    })
                    .catch(error => {
                        that.loading = false;
                    })
            );
        },
        cancel() {
            this.$emit('closeDialog');
        },
        submitData() {
            let _data = this.goodsList;
            if (_data.length == 0) {
                this.$util.warningMsg('没有可入仓商品');
                return;
            }
            for (let i = 0; i < _data.length; i++) {
                //商品的可入仓数
                let PV = Number(_data[i].Count) - Number(_data[i].WarehousedCount);
                //已选仓位商品的入仓总数
                let EV = 0;
                for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
                    if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
                        this.$util.warningMsg('请选择仓位');
                        return;
                    }
                    if (Number(_data[i].GoodsLocationList[j].Count) <= 0) {
                        this.$util.warningMsg('入库数量必须大于零');
                        return;
                    }
                    EV += Number(_data[i].GoodsLocationList[j].Count);
                }
                if (PV < EV) {
                    this.$util.warningMsg('【' + _data[i].GoodName + '】入库数量不可以超过未入库数量');
                    return;
                }
            }
            this.dailogLoading = true;
            this.formData.GoodsList = this.goodsList;
            this.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/ConfirmEntpPurOrderWarehousing',
                    data: this.formData,
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg('入仓成功');
                    let IsAllInWarehouse = res.data.IsAllInWarehouse;
                    this.$emit('closeDialog', true, IsAllInWarehouse);
                })
                .catch(() => {
                    this.dailogLoading = false;
                });
        },
        // 同仓入库-入库按钮
        tcrkSubmitData() {
            if (!this.tcrkWarehouseId) {
                this.$util.warningMsg('请选择仓库');
                return;
            }
            if (!this.tcrkShelfSpaceId) {
                this.$util.warningMsg('请选择仓位');
                return;
            }
            let _data = this.goodsList;
            _data.forEach(i1 => {
                i1.GoodsLocationList.forEach(i2 => {
                    i2.WarehouseId = this.tcrkWarehouseId;
                    i2.ShelfSpaceId = this.tcrkShelfSpaceId;
                    i2.ShelfSpacesList = this.tcrkShelfSpaceOptions;
                });
            });
            this.formData.GoodsList = _data;
            this.submitData();
        },
        //仓库的变换
        warehouseChange(value, goods, shelfSpace) {
            shelfSpace.ShelfSpacesList = [];
            shelfSpace.ShelfSpaceId = '';
        },
        //仓位的变换:选中值、商品、仓位
        positionChange(value, goods, shelfSpace) {
            if (!value) return;
            let that = this;
            let flag = 0;
            goods.GoodsLocationList.forEach(e => {
                if (e.ShelfSpaceId == value) {
                    flag++;
                    if (flag > 1) {
                        shelfSpace.ShelfSpaceId = '';
                        that.$util.warningMsg('同个商品不能选相同仓位');
                        return;
                    }
                }
            });
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, warehouseId, shelfSpace, goodsId) {
            if (!val || !warehouseId) return;
            let that = this;
            if (!(shelfSpace.ShelfSpacesList && shelfSpace.ShelfSpacesList.length > 0)) {
                shelfSpace.Key = '';
                shelfSpace.Page = 1;
                shelfSpace.StopLoad = false;
                that.searchPosition(
                    {
                        Key: '',
                        GoodsId: goodsId,
                        Page: 1
                    },
                    warehouseId
                ).then(() => {
                    that.$set(shelfSpace, 'ShelfSpacesList', [...that.PositionList]);
                });
            }
        },
        /**
         * 搜索仓位
         * 支持远程搜索和滚动下拉加载更多
         *   通过 val 判断是哪种情况，非空时是远程搜索
         */
        remoteMethod(val, goodsId) {
            let obj = this.currentShelfSpaceObj;
            if (goodsId) obj.GoodsId = goodsId;
            if (val) {
                // 远程搜索，重置搜索项
                obj.Key = val;
                obj.Page = 1;
                obj.StopLoad = false;
                obj.ShelfSpacesList = [];
            } else {
                // 下拉加载更多
                obj.Page += 1;
            }
            if (obj.StopLoad) return;
            this.searchPosition(
                {
                    Key: obj.Key,
                    GoodsId: obj.GoodsId,
                    Page: obj.Page
                },
                obj.WarehouseId
            ).then(() => {
                let row = {
                    ...obj,
                    StopLoad: this.PositionList.length < 20,
                    ShelfSpacesList: [...obj.ShelfSpacesList, ...this.PositionList]
                };
                this.currentShelfSpaceObj = row;
                // 覆盖下拉框数据
                this.goodsList.forEach((e1, idx1) => {
                    if (idx1 === this.firstIndex) {
                        e1.GoodsLocationList.forEach((e2, idx2) => {
                            if (idx2 === this.secoundIndex) {
                                this.$set(e2, 'ShelfSpacesList', row.ShelfSpacesList);
                            }
                        });
                    }
                });
            });
        },
        // 仓位下拉框聚焦
        shelfSpaceFocus(x, y, obj, goods) {
            this.firstIndex = x;
            this.secoundIndex = y;
            this.currentShelfSpaceObj = obj;
            this.currentShelfSpaceObj.GoodsId = goods.EntpTempGoodsId;
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore() {
            this.remoteMethod();
        },
        // 同仓入库搜索仓位
        tcrkRemoteMethod(value, tcrkWarehouseId) {
            if (!tcrkWarehouseId) return;
            let that = this;
            that.loading = true;
            that.$util
                .GetShelfSpacesList({
                    WarehouseId: tcrkWarehouseId,
                    ShelfSpaceCode: value,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: false
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.tcrkShelfSpaceOptions = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        },
        delItem(index, i) {
            let _data = { ...this.goodsList[index] };
            if (_data.GoodsLocationList.length != 1) {
                _data.GoodsLocationList.splice(i, 1);
                this.$set(this.goodsList, index, _data);
            }
        },
        addItem(index) {
            let that = this;
            //这是前一个选择的仓位
            let _target = that.goodsList[index].GoodsLocationList;
            let usedCount = 0; //已选数量
            for (let i = 0; i < _target.length; i++) {
                if (!_target[i].ShelfSpaceId) {
                    that.$util.warningMsg('请选择仓位');
                    return;
                }
                if (!_target[i].Count || !_target[i].Count < 0) {
                    that.$util.warningMsg('请填写正确的数量');
                    return;
                }
                usedCount += Number(_target[i].Count);
            }
            //当前商品
            let goods = { ...that.goodsList[index] };
            let canInCount = 0;
            //当前商品可入库数量
            if (goods.WarehousedCount > goods.InLabelCount) {
                canInCount = goods.Count - goods.PrintCount - (goods.WarehousedCount - goods.InLabelCount);
            } else canInCount = goods.Count - goods.PrintCount;
            //let canInCount = Number(goods.Count) - Number(goods.WarehousedCount);

            //剩余数量
            let surplus = canInCount - usedCount;
            let spaceItem = {
                WarehouseId: '',
                ShelfSpaceCode: '',
                ShelfSpaceId: '',
                Count: surplus > 0 ? surplus : 0,
                ShelfSpacesList: []
            };
            //如果原来订单有选仓库，默认使用选好的仓库
            if (that.OrderWarehouse) {
                for (var i = 0; i < that.WarehouseList.length; i++) {
                    if (that.WarehouseList[i].WarehouseId == that.OrderWarehouse.WarehouseId) {
                        spaceItem.ShelfSpacesList = that.WarehouseList[i].ShelfSpaces;
                        spaceItem.WarehouseId = that.OrderWarehouse.WarehouseId;
                        break;
                    }
                }
            }
            goods.GoodsLocationList.push(spaceItem);
            that.$set(that.goodsList, index, goods);
        }
    }
};
</script>
<style lang="less" scoped>
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.ops-ctn {
    text-align: left !important;
}
.dialog-header {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tips {
    color: #f00;
    margin-top: 4px;
    margin-left: 4px;
}
.dialog-footer {
    text-align: right;
}
.warehouseOut-main {
    padding: 10px 0;
}
.table-title {
    background: #f2f6fc;
    .cell-item {
        width: 33.33%;
    }
    .div-table-cell {
        text-align: center;
        height: 36px;
        line-height: 36px;
    }
}
.div-table-row {
    position: relative;
    overflow: visible;
}
.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cell-line {
        display: flex;
        width: 100%;
    }
    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
